import type { FunctionComponentWithRef } from "react";

import { Variant } from "./enums";
import { CenteredContainer, SpinnerIcon } from "./styles";
import { WheelIcon } from "./wheel-icon";

export type Props = {
  className?: string;
  variant?: Variant;
};

export const Loading: FunctionComponentWithRef<Props, HTMLImageElement> = ({
  className,
  ref: forwardReference,
  variant = Variant.Wheel,
  ...attributes
}) => {
  const getSource = () => {
    switch (variant) {
      case Variant.Spinner:
        return <SpinnerIcon />;
      case Variant.Wheel:
        return <WheelIcon />;
    }
  };

  return (
    <CenteredContainer className={className} {...attributes}>
      <div ref={forwardReference}>{getSource()}</div>
    </CenteredContainer>
  );
};

Loading.displayName = "Loading";
